import { Toaster as Sonner, type ToasterProps } from 'sonner';

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            'group flex items-start gap-3 rounded-xl border bg-white shadow-lg px-4 py-3 text-sm font-medium text-gray-900',
          error: 'border-error-200 bg-error-50 text-error-800 [&>[data-icon]]:text-error-500',
          success:
            'border-success-200 bg-success-50 text-success-800 [&>[data-icon]]:text-success-500',
          warning:
            'border-warning-200 bg-warning-50 text-warning-800 [&>[data-icon]]:text-warning-500',
          description: 'text-xs font-normal opacity-75 mt-0.5',
          closeButton: 'absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors',
        },
      }}
      {...props}
    />
  );
}
